/**
 * TTOC (Tipped Occupation) Codes reference data
 * IRS/DOL tipped occupation codes for tip credit compliance
 */
import { z } from "zod";
// ===== TTOC CODES =====
export const TTOC_CODE_OPTIONS = [
    { value: "101", label: "Waiter/Waitress" },
    { value: "102", label: "Host/Hostess" },
    { value: "103", label: "Busser" },
    { value: "104", label: "Runner" },
    { value: "105", label: "Barback" },
    { value: "201", label: "Bartender" },
    { value: "202", label: "Wine Steward/Sommelier" },
    { value: "203", label: "Barista" },
    { value: "301", label: "Valet" },
    { value: "302", label: "Bellhop" },
    { value: "303", label: "Concierge" },
    { value: "304", label: "Doorman" },
    { value: "305", label: "Porter" },
    { value: "306", label: "Room Service" },
    { value: "307", label: "Housekeeper" },
    { value: "401", label: "Hairdresser/Stylist" },
    { value: "402", label: "Barber" },
    { value: "403", label: "Nail Technician" },
    { value: "404", label: "Esthetician" },
    { value: "405", label: "Massage Therapist" },
    { value: "406", label: "Spa Attendant" },
    { value: "407", label: "Shampoo Person" },
    { value: "501", label: "Parking Attendant" },
    { value: "502", label: "Coat Check" },
    { value: "503", label: "Restroom Attendant" },
    { value: "504", label: "Casino Dealer" },
    { value: "505", label: "Caddy" },
    { value: "506", label: "Ski Instructor" },
    { value: "507", label: "Tour Guide" },
    { value: "508", label: "Fishing/Hunting Guide" },
    { value: "509", label: "Raft/Kayak Guide" },
    { value: "601", label: "Delivery Driver" },
    { value: "602", label: "Pizza Delivery" },
    { value: "603", label: "Courier" },
    { value: "604", label: "Newspaper Delivery" },
    { value: "605", label: "Furniture Delivery" },
    { value: "606", label: "Appliance Delivery" },
    { value: "607", label: "Moving Helper" },
    { value: "701", label: "Counter Service" },
    { value: "702", label: "Drive-Through" },
    { value: "703", label: "Carhop" },
    { value: "704", label: "Ice Cream Server" },
    { value: "705", label: "Coffee Server" },
    { value: "706", label: "Smoothie/Juice Bar" },
    { value: "707", label: "Deli Counter" },
    { value: "708", label: "Bakery Counter" },
    { value: "709", label: "Food Truck" },
    { value: "710", label: "Catering Server" },
    { value: "711", label: "Banquet Server" },
    { value: "712", label: "Buffet Attendant" },
    { value: "713", label: "Sushi Chef (customer-facing)" },
    { value: "714", label: "Teppanyaki Chef" },
    { value: "715", label: "Carver/Meat Cutter (customer-facing)" },
    { value: "801", label: "Tattoo Artist" },
    { value: "802", label: "Piercing Artist" },
    { value: "803", label: "Pet Groomer" },
    { value: "804", label: "Dog Walker" },
    { value: "805", label: "Car Wash Attendant" },
    { value: "806", label: "Boat Captain (charter)" },
    { value: "807", label: "Airport Skycap" },
    { value: "808", label: "Grocery Bagger" },
    { value: "809", label: "Furniture Assembly" },
];
export const TTOC_CODE_VALUES = TTOC_CODE_OPTIONS.map((o) => o.value);
export const TtocCodeSchema = z.enum(TTOC_CODE_VALUES);
// Helper to get label by code
export function getTtocLabel(code) {
    return TTOC_CODE_OPTIONS.find((o) => o.value === code)?.label;
}
